// @flow

import type { HierarchyAssignment, HierarchyAssignmentExclusion } from "@modules/service/types";

export function getSelectedIds(assignments: Array<HierarchyAssignment>): Array<number> {
  return assignments.map((a: HierarchyAssignment) => a.target.id);
}

export function getExcludedIds(assignments: Array<HierarchyAssignment>): Array<number> {
  return assignments.reduce(
    (acc: Array<number>, a: HierarchyAssignment) =>
      a.exclusions
        ? [...acc, ...a.exclusions.map((e: HierarchyAssignmentExclusion) => e.target.id)]
        : acc,
    [],
  );
}
